const qs = require('qs')

export function getQueryParamsObject () {
    if (typeof window !== 'undefined') {
        // remove the ? from the string
        const queryString = window.location.search.slice(1)
        return qs.parse(queryString)
    }
    return {}
}

export const getLastUrlSegment = () => {
    return window.location.pathname.split('/').pop()
}

export function buildQueryStringFromObject (queryObject) {
    let result = ''
    for (const param in queryObject) {
        if (result === '') {
            result += '?'
        } else {
            result += '&'
        }
        result += param + '=' + queryObject[param]
    }
    return result
}
